import React, { useState, useEffect } from 'react';
import useAxiosPrivate from "./hooks/useAxiosPrivate"

function CompanyPrice(props) {
    window.scrollTo(0, 0)
   // document.title = "Nivesh Karma Gurus: Invest with the best";
    const [pageData, setpageData] = useState({});
    const axiosPrivate = useAxiosPrivate();

    const companyDetails = async () => {
        setpageData({})
        let url = ""
        url = process.env.REACT_APP_BASE_URL + "/v1/price/" + props.companySymbol + "?access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;
        const cdresponse = await axiosPrivate.get(url);
        setpageData(cdresponse.data)

    }

    useEffect(() => {
        companyDetails()
    }, [])


    return (
        <div id="compInfo">
            <div id="CompanyMainCompanyName" style={props.source === "mobile"?{fontSize:"9px"}:{}}>
                {props.name }
            </div>
            <div id="CompanyMainCompanyEodDetails">
                <div id="CompanyMainCompanyEodPrice" style={props.source === "mobile" ? { fontSize: "8px" } : {}}>{pageData.price?.toLocaleString('en-IN', { maximumFractionDigits: 2, style: 'currency', currency: 'INR' })}</div>
                <div id="CompanyMainCompanyEodChange" style={props.source === "mobile" ? { fontSize: "7px", color: "rgb(255, 102, 102)", paddingTop: "4px"  } : { color: "rgb(255, 102, 102)" }} >{pageData.diff_prev_close}%</div>
                <div id="CompanyMainCompanyEodDate" style={props.source === "mobile" ? { fontSize: "6px", paddingTop:"4px"} : {}}>{pageData.quote_date}</div>
            </div>
        </div>
    );
}
export default CompanyPrice;